import AnalyticsClient from './analytics';

const client = new AnalyticsClient();

export default client;
